import { Typography } from '@design-system/components/typography/typography';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as styles from './UploadItem.css';
import { Button } from '@design-system/components/button/button';

type UploadItemProps = {
  name: string;
  thumbnailURL?: string;
  icon?: IconProp;
  progressValue: number;
  onCancel?: () => void;
  onRetry?: () => void;
  error: boolean;
};

const Progress = (p: { value: number }) => {
  const v = Math.max(Math.min(100, p.value), 0);
  return (
    <div className={styles.progressContainer}>
      <div className={styles.progressBar}>
        <div className={styles.progressFill} style={{ width: `${v}%` }} />
      </div>
      <Typography className={styles.progressLabel} variant="body">
        {v} %
      </Typography>
    </div>
  );
};

export const UploadItem = (p: UploadItemProps) => (
  <div className={styles.container}>
    <div className={styles.imageWrapper}>
      {p.icon ? (
        <FontAwesomeIcon icon={p.icon} className={styles.icon} />
      ) : p.thumbnailURL ? (
        <img src={p.thumbnailURL} className={styles.thumbnail} />
      ) : null}
    </div>
    <div className={styles.content}>
      <div className={styles.name}>
        <Typography variant="bodyLarge">{p.name}</Typography>
      </div>
      {p.error ? (
        <Typography variant="body" color="ERROR-100">
          File failed to upload
        </Typography>
      ) : p.progressValue === 100 ? (
        <Typography variant="body" color="SUCCESS-100">
          File uploaded successfully
        </Typography>
      ) : (
        <Progress value={p.progressValue} />
      )}
    </div>
    {p.onRetry && p.error && (
      <Button onClick={p.onRetry} variant="text" color="neutral">
        Try again
      </Button>
    )}
    {p.onCancel && p.error && (
      <div className={styles.cancelButton} onClick={p.onCancel} role="button">
        <FontAwesomeIcon icon={faTimes} />
      </div>
    )}
  </div>
);
